module.exports = __webpack_public_path__ + "media/images/lb/996-966f8089e8619a0fe6aaeb5c3d00516d.svg";